<button
  pButton
  class="p-button-text"
  [label]="label"
  [icon]="icon"
  [routerLink]="routerLink"
></button>
